import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-recently-viewed',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map